import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getSupabase } from './supabaseClient';
import { Spinner, Center, Box, Heading, Text, Button } from '@chakra-ui/react';

const ConfirmAdmin = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get('userId');

  useEffect(() => {
    const confirmAdminRole = async () => {
      const supabase = await getSupabase();
      if (!userId) {
        setError('Invalid request');
        setLoading(false);
        return;
      }

      const { error } = await supabase
        .from('users')
        .update({ role: 'admin' })
        .eq('id', userId);

      if (error) {
        setError('Failed to update the user role');
      }

      setLoading(false);
    };

    confirmAdminRole();
  }, [userId]);

  if (loading) {
    return (
      <Center height="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  return (
    <Center height="100vh">
      <Box textAlign="center">
        <Heading mb={4}>
          {error ? 'Error' : 'Success'}
        </Heading>
        <Text mb={6}>
          {error ? error : 'The user has been successfully granted admin privileges.'}
        </Text>
        <Button onClick={() => navigate('/')}>Go to Home</Button>
      </Box>
    </Center>
  );
};

export default ConfirmAdmin;
